import { render, staticRenderFns } from "./SetWithdraw.vue?vue&type=template&id=221d2195&scoped=true&"
import script from "./SetWithdraw.vue?vue&type=script&lang=js&"
export * from "./SetWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./SetWithdraw.vue?vue&type=style&index=0&id=221d2195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d2195",
  null
  
)

export default component.exports